import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { List as IList } from 'immutable';
import LaunchSharpIcon from '@mui/icons-material/LaunchSharp';
import DrawerComponent from './DrawerComponent';
import headerMessages from './message/HeaderMessage';
import Logo from './Logo';
import dynamicLinkMessages from '../brand/messages/DynamicLinkMessages';
import { getIntlLocale, getIntlCurrencyCode } from '../intl/intlSelectors';
import { getSupportedLocales } from '../brand/brandSelectors';



import {
    getCurrencyPickerStatus,
    getManageGiftcardsStatus,
    getLoginButtonStatus
} from '../localeCurrencyPicker/LocaleCurrencyPickerSelector';
import LanguageCurrencySelect from './LanguageCurrencySelect';
import CartIcon from '../cart/cartIcon';
import { localeDetails } from '../localeCurrencyPicker/CurrencyLocaleUtils';
import { trackHeaderFooterClick } from '../segment/segmentModule';
import { getSSOEnabled, getEnv } from '../app/bootstrap';
import {
    getIsAuthenticated,
    getFirstName,
    getFullName,
    getLoyaltyNumber
} from '../auth/authSelectors';
import { getAuthLoginPath, getAuthLogoutPath } from '../routing/paths';
import SsoUserDrawer from './SsoUserDrawer';
import Loader from '../loader/loader';

const NewHeaderContainer = ({
    intl,
    locale,
    selectedCurrency,
    callbackIsOpen,
    handleClickLocation,
    supportedLocales,
    isCurrencyPickerStatus,
    isManageGiftcardsStatus,
    trackExternalLinkClickAction,
    isDialogOpen,
    isAuthenticated,
    firstName,
    fullName,
    loyaltyNumber,
    isLoginButtonEnabled
}) => {
    const handleClickOpen = () => {
        if (!supportedLocales || supportedLocales.size <= 1) return;
        callbackIsOpen(true);
        handleClickLocation('Header');
    };
    const { fullySupportedLocalesUniqueArr, localesForSelectedCountry } = localeDetails(supportedLocales, locale);

    const ssoEnabled = getSSOEnabled();

    
    
    const [isRedirecting, setIsRedirecting] = useState(false);

    
    
    
    
    
    const getSafeReturnTo = () => {
        if (typeof window === 'undefined') return '/';
        const path = `${window.location.pathname}${window.location.search}`.split('#')[0];
        if (!path.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) {
            return '/';
        }
        return path;
    };

    
    
    
    const getLoginHref = () => (
        `${getAuthLoginPath()}?returnTo=${encodeURIComponent(getSafeReturnTo())}&prompt=login`
    );

    
    
    
    
    const handleLoginClick = (event) => {
        event.preventDefault();
        setIsRedirecting(true);
        window.location.assign(getLoginHref());
    };

    const handleLogoutClick = () => {
        const returnTo = getSafeReturnTo();
        setIsRedirecting(true);
        window.location.assign(`${getAuthLogoutPath()}?returnTo=${encodeURIComponent(returnTo)}`);
    };

    return (
        <>
            {isRedirecting && <Loader showTestEnv={getEnv() !== 'PROD'} />}
            <Box className='header header-new'>
                <Logo />
                <div className='headerTab newHeaderTab'>
                    <div className='header-right'>
                        <div style={{ visibility: isManageGiftcardsStatus ? 'visible' : 'hidden' }}>
                            <Link
                                className='manage-gift-card-text manage-gift-cards header-text'
                                href={intl.formatMessage(
                                    dynamicLinkMessages.manageGiftCard, { selectedLocale: locale }
                                )}
                                disableRipple
                                rel='noreferrer noopener'
                                target='_blank'
                                onClick={() => {
                                    trackExternalLinkClickAction('Header Link Click',
                                        {
                                            title: intl.formatMessage(headerMessages.manageGiftCard),
                                            path: intl.formatMessage(dynamicLinkMessages.manageGiftCard)
                                        });
                                }}
                            >
                                <CardGiftcardIcon
                                    className='manage-gift-card-icon'
                                    sx={{
                                        ml: 0.5,
                                        color: 'inherit',
                                        
                                        '& path': { fill: 'currentColor' }
                                    }}
                                />
                                <span className='manage-gift-card-flex'>
                                    {intl.formatMessage(
                                        headerMessages.manageGiftCard
                                    )}
                                </span>
                                <LaunchSharpIcon
                                    className="manage-gift-card-text-external-link manage-gift-card-text"
                                    titleAccess="- opens in a new window"
                                />
                            </Link>
                        </div>
                        <LanguageCurrencySelect
                            intl={intl}
                            locale={locale}
                            fullySupportedLocalesUniqueArr={
                                fullySupportedLocalesUniqueArr
                            }
                            localesForSelectedCountry={
                                localesForSelectedCountry
                            }
                            isCurrencyPickerStatus={
                                isCurrencyPickerStatus
                            }
                            handleClickOpen={handleClickOpen}
                            selectedCurrency={selectedCurrency}
                            isDialogOpen={isDialogOpen}
                        />
                        {ssoEnabled && (isAuthenticated ? (
                            <SsoUserDrawer
                                firstName={firstName}
                                fullName={fullName}
                                loyaltyNumber={loyaltyNumber}
                                onLogout={handleLogoutClick}
                            />
                        ) : (isLoginButtonEnabled && (
                            <Button
                                className='sso-login-button'
                                component='a'
                                href={getLoginHref()}
                                variant='contained'
                                disableRipple
                                onClick={handleLoginClick}
                            >
                                {intl.formatMessage(headerMessages.logIn)}
                            </Button>
                        )))}
                        <CartIcon />
                        <DrawerComponent
                            intl={intl}
                            locale={locale}
                            handleClickOpen={handleClickOpen}
                            fullySupportedLocalesUniqueArr={
                                fullySupportedLocalesUniqueArr
                            }
                            localesForSelectedCountry={
                                localesForSelectedCountry
                            }
                            isCurrencyPickerStatus={
                                isCurrencyPickerStatus
                            }
                            selectedCurrency={selectedCurrency}
                            isDialogOpen={isDialogOpen}
                            isNewDrawer
                        />
                    </div>
                </div>
            </Box>
        </>
    );
};

NewHeaderContainer.defaultProps = {
    supportedLocales: IList()
};

NewHeaderContainer.propTypes = {
    intl: intlShape.isRequired,
    locale: PropTypes.string.isRequired,
    selectedCurrency: PropTypes.string.isRequired,
    callbackIsOpen: PropTypes.func.isRequired,
    handleClickLocation: PropTypes.func.isRequired,
    supportedLocales: PropTypes.instanceOf(IList),
    isCurrencyPickerStatus: PropTypes.bool.isRequired,
    isManageGiftcardsStatus: PropTypes.bool.isRequired,
    trackExternalLinkClickAction: PropTypes.func.isRequired,
    isDialogOpen: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    firstName: PropTypes.string,
    fullName: PropTypes.string,
    loyaltyNumber: PropTypes.string,
    isLoginButtonEnabled: PropTypes.bool
};

const mapStateToProps = state => ({
    locale: getIntlLocale(state),
    selectedCurrency: getIntlCurrencyCode(state),
    supportedLocales: getSupportedLocales(state),
    isCurrencyPickerStatus: getCurrencyPickerStatus(state),
    isManageGiftcardsStatus: getManageGiftcardsStatus(state),
    isAuthenticated: getIsAuthenticated(state),
    firstName: getFirstName(state),
    fullName: getFullName(state),
    loyaltyNumber: getLoyaltyNumber(state),
    isLoginButtonEnabled: getLoginButtonStatus(state)
});

const mapDispatchToProps = {
    trackExternalLinkClickAction: trackHeaderFooterClick
};

NewHeaderContainer.defaultProps = {
    isDialogOpen: false,
    isAuthenticated: false,
    firstName: null,
    fullName: null,
    loyaltyNumber: null,
    isLoginButtonEnabled: true
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NewHeaderContainer));
